var _defs, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultBannerDriver(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 719 332",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1 {\n            fill: url(#radial-gradient);\n            stroke: #d9d9d9;\n            strokeMiterlimit: 10;\n            }\n        "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 364,
    cy: 171.5,
    fx: 364,
    fy: 171.5,
    r: 314.17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#55c2a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b8871"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.5,
    y: 39.5,
    width: 661,
    height: 264,
    rx: 12,
    ry: 12
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultBannerDriver);
export default __webpack_public_path__ + "static/media/defaultBannerDriver.939735eee7aca7b71beafe958a3b65f8.svg";
export { ForwardRef as ReactComponent };